import { SuggestedOrderFrequency } from '../types';

export default [
  {
    value: SuggestedOrderFrequency.ALWAYS,
    label: 'Always',
  },
  {
    value: SuggestedOrderFrequency.SOMETIMES,
    label: 'Sometimes',
  },
  {
    value: SuggestedOrderFrequency.NEVER,
    label: 'Never',
  },
];
